export enum BookingErrorType {
    AlreadyBooked = 'AlreadyBooked',
    Unknown = 'Unknown'
}

export class BookingError extends Error {
    name = 'BookingError';
    type: BookingErrorType;

    constructor(type: BookingErrorType, message?: string) {
        super(message ?? BookingErrorMessages[type]);

        this.type = type;
    }
}

export const BookingErrorMessages: Record<BookingErrorType, string> = {
    [BookingErrorType.AlreadyBooked]:
        'You already booked an appointment for this pet today. Please cancel previous appointment to continue booking.',
    [BookingErrorType.Unknown]: 'Oops, something went wrong.'
};
